<template>
  <v-container fluid>
    <v-row align="center" justify="center" class="mx-0">
      <v-col cols="12">
        <v-card v-if="!userProfile.email.includes('@pappyon.com')">
          <v-card-title>
            <div class="text-h5">Forbidden</div>
          </v-card-title>
        </v-card>

        <v-card outlined v-else>
          <v-card-title>
            <div class="text-h5">Analytics</div>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="8">
                <v-row>
                  <v-col cols="6">
                    <span class="mr-8"
                      >Total Subscriptions:
                      <span class="text--primary text-body-1">{{
                        allBusinessProfiles.length
                      }}</span></span
                    >
                    <span
                      >Total Team Members:
                      <span class="text--primary text-body-1">{{
                        allCardholders.length
                      }}</span></span
                    >
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      rounded
                      bordered
                      v-model="search"
                      append-icon="mdi-magnify"
                      outlined
                      label="Search"
                      dense
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-data-table
                      :headers="headers"
                      :items="allBusinessProfiles"
                      :search="search"
                      @click:row="handleBusinessProfileClick"
                      class="row-pointer"
                    >
                      <template v-slot:item.plan="{ item }">
                        {{ item.plan == "evolve" ? "Evolve" : "Grow" }}
                      </template>
                      <template v-slot:item.subscriptionStatus="{ item }">
                        {{
                          item.subscriptionStatus == "active"
                            ? "Active"
                            : "On Free Trial"
                        }}
                      </template>
                      <template v-slot:item.billingPeriod="{ item }">
                        {{
                          item.billingPeriod == "yearly" ? "Yearly" : "Monthly"
                        }}
                      </template>
                      <template v-slot:item.id="{ item }">
                        {{ getContactName(item.id) }}
                      </template>
                      <template v-slot:item.generalContactEmail="{ item }">
                        {{ getContactEmail(item.id) }}
                      </template>
                      <template v-slot:item.noOfCardsIssued="{ item }">
                        {{ getNumberOfCardsIssued(item.id) }}
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="4">
                <v-card height="150"> </v-card>
                <v-card
                  min-height="590"
                  v-if="selectedBusinessProfileId != ''"
                  color="grey lighten-4"
                  class="pa-2"
                >
                  <div class="text-h6 mb-4 text--primary">
                    {{ selectedBusinessProfileName }}
                  </div>
                  <div class="text-body-1 text--primary">Team Members</div>
                  <div class="text--secondary">
                    Total: {{ selectedBusinessProfileCardHolderList.length }}
                  </div>
                  <v-list
                    color="transparent"
                    v-if="selectedBusinessProfileCardHolderList.length > 0"
                    two-line
                    subheader
                    class="ma-0 pa-0"
                  >
                    <v-list-item
                      v-for="cardholder in selectedBusinessProfileCardHolderList"
                      :key="cardholder.id"
                      class="my-0 py-0"
                    >
                      <UserAvatar
                        :key="cardholder.businessCardId"
                        :usersInitials="
                          cardholder.firstName[0] + cardholder.lastName[0]
                        "
                        :displayImageUrl="cardholder.displayImageUrl || ''"
                      />
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-medium">{{
                          cardholder.firstName + " " + cardholder.lastName
                        }}</v-list-item-title>
                        <v-list-item-subtitle>{{
                          cardholder.email
                        }}</v-list-item-subtitle>
                        <v-list-item-subtitle>{{
                          cardholder.jobTitle
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                  <div class="text-center my-16 py-16" v-else>
                    No team members.
                  </div>
                </v-card>
                <v-card color="grey lighten-4" min-height="590" v-else>
                  <v-card-text>
                    <div class="text-center pt-16 pb-5">
                      <v-icon size="50" color="orange lighten-3"
                        >mdi-cursor-default-click</v-icon
                      >
                    </div>
                    <div class="text-body-2 text--secondary text-center">
                      No Business Profile Selected
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";

import UserAvatar from "@/components/UserAvatar";
import {
  getQueryBusinessCardsCollection,
  getQueryBusinessPortalAccessCollection,
  getQueryBusinessProfilesCollection
} from "@/shared/firebase_utils";
import {where} from "firebase/firestore";

export default {
  components: {
    UserAvatar,
  },
  created() {
    // this.getBusinessProfilesData();
    // this.getBusinessProfileAdmins();
    // this.getAllCardholders();
  },
  methods: {
    handleBusinessProfileClick(item) {
      this.selectedBusinessProfileId = item.id;
    },
    async getAllCardholders() {
      let querySnapshot0 = await getQueryBusinessCardsCollection(
          where("subscriptionType", "==", "GROW"),
          where("status", "==", "Active")) ;
      let formatted0 = querySnapshot0.docs.map((doc) => {
        return { ...doc.data(), id: doc.id };
      });

      let querySnapshot1 = await getQueryBusinessCardsCollection(
          where("subscriptionType", "==", "GROW"),
          where("status", "==", "Pending")) ;
      let formatted1 = querySnapshot1.docs.map((doc) => {
        return { ...doc.data(), id: doc.id };
      });

      let formatted = [...formatted0, ...formatted1];
      console.log("All cardholders: ");
      console.log(JSON.stringify(formatted));
    },
    async getBusinessProfileAdmins() {
      let querySnapshot = await getQueryBusinessPortalAccessCollection(
          where("privilegeLevel", "==", "admin"),
          where("status", "==", "active")
      );

      let formatted = querySnapshot.docs.map((doc) => {
        return { ...doc.data(), id: doc.id };
      });
      onsole.log("All admins: ");
      console.log(JSON.stringify(formatted));
    },
    getContactName(businessProfileId) {
      let admins = this.allAdmins.filter(
        (admin) => admin.businessProfileId == businessProfileId
      );
      if (admins.length > 0)
        return admins[0].firstName + " " + admins[0].lastName;
      return "";
    },
    getNumberOfCardsIssued(businessProfileId) {
      let noOfCardsIssued = this.allCardholders.filter(
        (cardholder) => cardholder.businessProfileId == businessProfileId
      );
      return noOfCardsIssued.length;
    },
    getContactEmail(businessProfileId) {
      let admins = this.allAdmins.filter(
        (admin) => admin.businessProfileId == businessProfileId
      );
      if (admins.length > 0) return admins[0].email;
      return "";
    },
    async getBusinessProfilesData() {
      let querySnapshot0 = await getQueryBusinessProfilesCollection(where("subscriptionStatus", "==", "trialing"));
      let formatted0 = querySnapshot0.docs.map((doc) => {
        return { ...doc.data(), id: doc.id };
      });

      let querySnapshot1 = await getQueryBusinessProfilesCollection(where("subscriptionStatus", "==", "active"));
      let formatted1 = querySnapshot1.docs.map((doc) => {
        return { ...doc.data(), id: doc.id };
      });

      let formatted = [...formatted0, ...formatted1];
      console.log("All business profiles");
      console.log(JSON.stringify(formatted));
    },
  },
  data() {
    return {
      selectedBusinessProfileId: "",
      search: "",
      headers: [
        { text: "Business Name", value: "businessName" },
        { text: "Plan Type", value: "plan" },
        { text: "Payment Frequency", value: "billingPeriod" },
        { text: "No. of cards issued", value: "noOfCardsIssued" },
        { text: "No. of team members", value: "noOfEmployees" },
        { text: "Subscription Status", value: "subscriptionStatus" },
        { text: "Contact Name", value: "id" },
        { text: "Contact Email", value: "generalContactEmail" },
      ],
      desserts: [
        {
          name: "Frozen Yogurt",
          calories: 159,
          fat: 6.0,
          carbs: 24,
          protein: 4.0,
          iron: "1%",
        },
        {
          name: "Ice cream sandwich",
          calories: 237,
          fat: 9.0,
          carbs: 37,
          protein: 4.3,
          iron: "1%",
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "allBusinessProfiles",
      "allCardholders",
      "allAdmins",
      "userProfile",
    ]),
    selectedBusinessProfileCardHolderList() {
      return this.allCardholders.filter(
        (cardholder) =>
          cardholder.businessProfileId == this.selectedBusinessProfileId
      );
    },
    selectedBusinessProfileName() {
      let businessProfile = this.allBusinessProfiles.filter(
        (businessProfile) =>
          businessProfile.id == this.selectedBusinessProfileId
      );
      if (businessProfile.length > 0) return businessProfile[0].businessName;
      return "";
    },
  },
};
</script>
<style lang="css" scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>